import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";

// read only energy fetched from iot, same ui as the start energy column
const EnergyValue = ({ value, loading = false }) => {
  if (loading) {
    return <Spin indicator={<LoadingOutlined />} size="small" />;
  }

  const hasValue = value !== null && value !== undefined && value !== "";

  return (
    <div className="flex items-center">
      <ChargerIcon size={16} className="text-green" />
      <p className="ml-2 font-aileron text-10 font-semibold text-green">
        {hasValue ? value : "--"} kWh
      </p>
    </div>
  );
};

export default EnergyValue;
